import React, { Fragment, useEffect, useState } from "react";
import twilioimg from "../../assets/utils/images/Intagration image/twilio.svg";
import { cardData } from "./Constants";
import requestApiService from "../../services/requestApi.service";
import ShowIntegrationInfo from "./ShowIntDetails.js";

const Twilio = (props) => {
    let { isInstalation, buttonValue, unInstall, name } = props;
    const [isConnected, setConnectionStatus] = useState(false);
    const [accountInfo, setAccountInfo] = useState([]);
    const [carddata, setData] = useState(cardData);
    let key = "";
    let foundData = carddata.find((data) => data.name === "twilio");
    if (foundData) {
        key = foundData.name;
    }

    useEffect(() => {
        (async () => {
            await fetchCalAccountDetails();
        })();
    }, [buttonValue]);

    const fetchCalAccountDetails = async () => {
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "LOAD_INTEGRATIONS",
            TYPE: name,
        };
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let integrationInfo = response.data;
            if (integrationInfo.length > 0) {
                setConnectionStatus(true);
                const connectedInfo = JSON.parse(integrationInfo[0][2] || "{}");
                const { apiKey, authToken, phoneno } = connectedInfo.data || {};
                let IntegrationAccountInfo = [
                        { type: "id", id: integrationInfo[0][0] },
                        { type: "text", label: "SID ", value: apiKey },
                        { type: "text", label: "Phone Number ", value: phoneno },
                        { type: "text", label: "Auth Token ", value: authToken },
                    ];
                setAccountInfo(IntegrationAccountInfo);
            } else {
                setAccountInfo([]);
                setConnectionStatus(false);
            }
        }
    };

    const onOpenModal = (type, openModule = false) => {
        isInstalation(type, openModule, "twilio", "SMS");
    };

    const integrationHeadData = {
        name: "Twilio",
        tag: "SMS",
        image: twilioimg,
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
    };
    // change the twilio Content 
    const integrationContent = [
        { heading: "Website", subheading: "https://twilio.com", type: "url" },
        { heading: "Overview", subheading: "Integrate Twilio SMS with our platform to send and receive text messages using your Twilio number. Automate customer updates, reminders, and follow-ups via SMS.", type: "text" },
        { heading: "Key Benefits", 
            subheading: [
                { 
                    description: "Send personalized, automated SMS using your Twilio account.",
                    // description: "Free up valuable time by allowing our AI-powered agents to take over appointment bookings and rescheduling tasks. integrates with Cal.com to check real-time availability and instantly confirm bookings on your behalf." 
                },
                { 
                    description: "Trigger SMS from AI workflows, appointment events, or user actions.", 
                    // description: "Provide a smoother, faster experience by offering 24/7 booking capabilities. AI agents can assist customers anytime, checking availability and scheduling appointments within seconds." 
                },
                { 
                    description: "Ensure fast delivery and high engagement with real-time message tracking.", 
                    // description: "All appointments are automatically synced with your Cal.com calendar, ensuring you and your team have the latest information without needing manual updates." 
                },
                {
                    description: "Maintain compliance and deliverability with Twilio’s secure SMS infrastructure.",
                }
        ], type: "list" }
    ];

    return (
        <Fragment>
            <div className="agent-details">
                <ShowIntegrationInfo
                    keyname={name}
                    headData={integrationHeadData}
                    integrationData={integrationContent}
                    isInstalled={buttonValue.includes(name)}
                    isConnected={isConnected}
                    accountInfo={accountInfo}
                    onInstall={onOpenModal}
                    onRemove={unInstall}
                />
            </div>
        </Fragment>
    );
};

export default Twilio;